<div class="component-main-filter">
  <div class="component-main-filter__left">
    <span class="component-main-filter__count">{{ reportCount }} reports</span>
    <button class="component-main-filter__pill component-main-filter__pill--active"
            (click)="singleEmitClickedFilter($event)" data-filter-by="">All</button>
    <button class="component-main-filter__pill"
            (click)="singleEmitClickedFilter($event)" data-filter-by="favorites">Saved</button>
    <button class="component-main-filter__pill"
            (click)="singleEmitClickedFilter($event)" data-filter-by="report_viewes">Most viewed</button>
    <button class="component-main-filter__pill"
            (click)="singleEmitClickedFilter($event)" data-filter-by="date_modified">Recent</button>
  </div>
  <div class="component-main-filter__right">
    <button class="component-main-filter__sort-btn">Sort: A–Z ▾</button>
  </div>
</div>
